import { sendNonBlocking } from '../utilities/analytics';
import { getEnvironment } from '../Infrastructure/firebase';
import { getOrCreateVisitorId } from '../utilities/cookieUtils';
import { getAuth } from 'firebase/auth';

export const EVENT_APP_USAGE = 702;

export interface AppUsageContext {
    campaignCode?: string | null;
    variantName?: string | null;
    planName?: string;
    timeOnPage?: number;
    customContext?: { key: string; value: string };
}

export function reportAppUsage(
	feature: string,
    context: AppUsageContext = {}
): void {
	const visitorId = getOrCreateVisitorId();
	const env = getEnvironment();
	
    // Try to get auth user if available (note: this might be null during fast loading if auth hasn't initialized yet)
    // For fast loader, we rely mostly on visitorId as it happens before main app/auth load often.
    const auth = getAuth();
    const userId = auth.currentUser?.uid || visitorId;
    
    const planName = context.planName || 'Unknown';

	// Primary: What
	const primary = `feature:${feature}`;

	// Secondary: Who
    // user-id:xxx|user-plan:yyy
	const secondary = `user-id:${userId}|user-plan:${planName}`;

	// Tertiary: Context
    // time-on-page:xxx|campaign:xxx|variant:xxx|key:value
	const parts: string[] = [];
    
    if (context.timeOnPage !== undefined) {
        parts.push(`time-on-page:${context.timeOnPage}`);
    }

    if (context.campaignCode) {
        parts.push(`campaign:${context.campaignCode}`);
    }
    
    if (context.variantName) {
        parts.push(`variant:${context.variantName}`);
    }
    
    if (context.customContext) {
        parts.push(`${context.customContext.key}:${context.customContext.value}`);
    }
    
	const tertiary = parts.join('|');

    if (env === 'dev') {
        console.log('Reporting App Usage:', {
            primary,
            secondary,
            tertiary
        });
    }

	sendNonBlocking('/api/events', {
		UtcTimeEpoch: Date.now(),
		EventType: EVENT_APP_USAGE,
		UserId: userId,
		PrimaryParameter: primary,
		SecondaryParameter: secondary,
		TertiaryParameter: tertiary,
		Environment: env,
	});
}
